import { OpenApprovalsSearchRequest } from "./OpenApproval";
import { OpenCalcReviewsSearchRequest } from "./OpenCalculationReview";
import { OpenRequestsSearchRequest } from "./OpenRequest";
import { Task, TasksSearchRequest } from "./Task";

export interface DashboardState {
    isLoading: Boolean,
    error: string,
    searchOpenCalcReviewsPayload?: OpenCalcReviewsSearchRequest,
    searchOpenApprovalsPayload?: OpenApprovalsSearchRequest,
    searchOpenRequestsPayload?: OpenRequestsSearchRequest,
    searchOpenTasksPayload?: TasksSearchRequest,
    selectedNotifications: Task[]
}

export const initialState: DashboardState = {
    isLoading: true,
    error: '',
    selectedNotifications: []
};